import { HcpcsPricing } from '../../types/code.types';

interface MedicarePricingProps {
  pricing: HcpcsPricing | null;
}

const formatCurrency = (amount: number) => new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount);

const formatQuarter = (quarter: string) => {
  const match = quarter.match(/^(\d{4})Q([1-4])$/);
  return match ? `Q${match[2]} ${match[1]}` : quarter;
};

const MedicarePricing = ({ pricing }: MedicarePricingProps) => {
  if (!pricing) return null;
  return (
    <div className="bg-white rounded-lg shadow-md p-6">
      <h2 className="text-2xl font-bold mb-4">💲 Medicare Pricing & Status</h2>
      <div className="p-3 bg-gray-50 rounded-lg">
        <p className="text-sm text-gray-500">Medicare Part B payment limit, {formatQuarter(pricing.quarter)}</p>
        {pricing.paymentLimit !== null && (
          <p className="text-2xl font-bold text-primary-700 mt-1">
            {formatCurrency(pricing.paymentLimit)}
            <span className="text-sm font-normal text-gray-500 ml-2">per {pricing.pricingUnit}</span>
          </p>
        )}
        {pricing.notes && <p className="text-sm text-gray-500 mt-2">{pricing.notes}</p>}
      </div>
    </div>
  );
};

export default MedicarePricing;
